import RequestSource from '@shared/services/main/request/tokens';

/**
 * This prototype describes a request client cancellable trait. Encapsulate business logics
 *
 * @class      RequestCancellable (name)
 */
function RequestCancellable(component) {
  this.component = component;
}

/**
 * Renew request client cancel token
 *
 * @param      {request client}  reques_client  The requesdt client instance
 * @param      {String}          token_key     The token key
 * @return     {CancelToken}     { description_of_the_return_value }
 */
RequestCancellable.prototype.renewCancelToken = function(reques_client, token_key) {
  this.cancelRequest(token_key);
  var token_source = RequestSource.createCancelToken(reques_client, token_key);
  return token_source;
}

/**
 * Cancel an request client token
 *
 * @param      {String}  token_key  The token key
 */
RequestCancellable.prototype.cancelRequest = function(token_key) {
  var token_source = RequestSource.getCancelToken(token_key);
  if (token_source) {
    token_source.cancel();
  }
  return this;
}

/**
 * Cancel all acios token
 *
 * @param      {Object}  cancel_tokens  The cancel tokens
 */
RequestCancellable.prototype.cancelAllRequests = function(cancel_tokens) {
  var tokens = cancel_tokens || this.event_group;
  const keys = Object.entries(tokens);
  for (const [, key] of keys) {
    this.cancelRequest(key);
  }
  return this;
}

export default RequestCancellable;
